import { Component, OnInit } from '@angular/core';
import { LibraryService } from 'src/app/services/Library/library.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-generate-library-card-no',
  templateUrl: './generate-library-card-no.component.html',
  styleUrls: ['./generate-library-card-no.component.css']
})
export class GenerateLibraryCardNoComponent implements OnInit {

  PersonTypeList:any;
  ClassList:any;
  StudentList:any;
  SectionList:any;
  Submitted:boolean=false;
  DesignationList:any;
  DepartmentList:any;
  EmployeeTypeList:any;
  StaffList:any;
  EmployeeCategoryList:any;
  Student:any;
  BranchDetails:any;
  Count1:any;

  constructor(private  libraryservice: LibraryService,private lookupservice: LookupService, public globalHelper: GlobalHelper, 
    private spinnerService: Ng4LoadingSpinnerService) { }

  GenerateLibraryCardNoModel = {
    ClassID: 0,
    SectionID: 0,
    StudentID: 0,
    TemplateID: 0,
    PersonTypeID: 0,
    EmployeeCategoryID: 0,
    EmploymentStatus: 0,
    EmployeeTypeID: 0,
    PrimaryDepartmentID: 0,
    DesignationID: 0,
    CurrentIndex: 0,
    PageSize: 0,
    Message: '',
}

LibraryModel={

}

printdetails  (item) {
  
    this.LibraryModel = item;

}
PrintBulkStudent  () {
    var url = "../../../App/Library/LibraryCard/PrintLibraryCard.html?PersonTypeID=" + this.GenerateLibraryCardNoModel.PersonTypeID + "&ClassID=" + this.GenerateLibraryCardNoModel.ClassID + "&SectionID=" + this.GenerateLibraryCardNoModel.SectionID + "&StudentID=" + this.GenerateLibraryCardNoModel.StudentID;
    this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");
}
Print  () {
    
        var divContents = document.getElementById("dvContainer").innerHTML;
        divContents = divContents.replace('no record found', '');
        var printWindow = window.open('', '', 'height=400,width=600');
        printWindow.document.write('<html><head><title>Library Card</title>');
        printWindow.document.write('<style type="text/css">');
        printWindow.document.write('.t1{ border-top: 1px solid black;  border-left: 1px solid black;white-space:nowrap;font-family:Calibri;font-size:10px} .t2 { border-right: 1px solid black; border-bottom: 1px solid black;}.t3 { border-right: 1px solid black;border-bottom: 1px solid black; }');
        printWindow.document.write('</style>');
        printWindow.document.write('</head><body >');
        printWindow.document.write(divContents);
        printWindow.document.write('</body></html>');
        printWindow.document.close();
        printWindow.print();
    
}
GetClass () {
    this.lookupservice.GetLookupsList('Class', '').subscribe( (data:any)=> {
        this.ClassList = data.LookupItems;
    });
};
GetPersonType  () {
  this.lookupservice.GetLookupsList('PersonType', '').subscribe( (data:any)=> {
        this.PersonTypeList = data.LookupItems;
    });
};
GetSection  () {
    this.GenerateLibraryCardNoModel.SectionID = 0;
    this.GenerateLibraryCardNoModel.StudentID = 0;
    this.StudentList = [];
   this.spinnerService.show();
    var ItemBo = {
        ItemID: this.GenerateLibraryCardNoModel.ClassID
    }
    this.lookupservice.GetLookupsList('SectionName', JSON.stringify(ItemBo)).subscribe( (data:any)=> {
        this.SectionList = data.LookupItems;
       this.spinnerService.hide();
    });

};
GetStudent  () {
    this.GenerateLibraryCardNoModel.StudentID = 0;
    this.StudentList = [];
    this.spinnerService.show();
    var itemBo = {
        'ItemId': this.GenerateLibraryCardNoModel.ClassID,
        'ItemId2': this.GenerateLibraryCardNoModel.SectionID
    };
    this.lookupservice.GetLookupsList('Student', JSON.stringify(itemBo)).subscribe( (data:any)=> {
        this.Student = data.LookupItems;
        this.spinnerService.hide();
    });
};

 Validation() {
    return this.GenerateLibraryCardNoModel.ClassID == 0;
}

GetGenerateLibraryCardNoStudent () {
    this.Submitted = true;           
    if (!this.Validation()) {
   this.spinnerService.show();
    this.libraryservice.GetGenerateLibraryCardNoStudent(JSON.stringify(this.GenerateLibraryCardNoModel)).subscribe( (response:any)=> {
        this.Submitted = false;
        this.StudentList = response.StudentList;
        this.BranchDetails = response.BranchDetails;
       this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
    });
  }
};
GetDesignation  () {
    var itembo = {
        'ItemID': 1,
    }
    this.lookupservice.GetLookupsList('Designation', JSON.stringify(itembo)).subscribe( (data:any) => {
        this.DesignationList = data.LookupItems;
    });
};
GetDepartment () {
    this.lookupservice.GetLookupsList('Department','').subscribe( (data:any) => {
        this.DepartmentList = data.LookupItems;
        
    });
};
GetEmployeeCategory  () {
  this.lookupservice.GetLookupsList('PersonnelType','').subscribe( (data:any) => {
        this.EmployeeCategoryList = data.LookupItems;
        
    });
};
GetEmployeeType  () {

    this.lookupservice.GetLookupsList('EmployeeType', '').subscribe( (data:any)=> {
        this.EmployeeTypeList = data.LookupItems;
    });
};

GetGenerateLibraryCardNoStaff  () {
    this.spinnerService.show();
    this.libraryservice.GetGenerateLibraryCardNoStaff(JSON.stringify(this.GenerateLibraryCardNoModel)).subscribe( (response:any) =>{
        this.StaffList = response.StaffList;
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(response);
       
    });
};

ChangePersonType  () {
    this.StaffList = [];
    this.StudentList = [];
    this.SelectModel.IsSelect = false;
    for (var i = 0; i < this.StudentList.length; i++) {

        this.StudentList[i].Active = false;

    }
    for (var i = 0; i < this.StaffList.length; i++) {
        this.StaffList[i].Active = false;

    }
}

SelectModel = {
  IsSelect:false,
}

  
SelectAll  () {

    if (this.SelectModel.IsSelect && this.GenerateLibraryCardNoModel.PersonTypeID == 2) {
        for (var i = 0; i < this.StudentList.length; i++) {

            this.StudentList[i].Active = true;

        }
    }
    if (this.SelectModel.IsSelect == false && this.GenerateLibraryCardNoModel.PersonTypeID == 2) {
        for (var i = 0; i < this.StudentList.length; i++) {
            this.StudentList[i].Active = false;

        }
    }

    if (this.SelectModel.IsSelect && this.GenerateLibraryCardNoModel.PersonTypeID == 1) {
        for (var i = 0; i < this.StaffList.length; i++) {

            this.StaffList[i].Active = true;

        }
    }
    if (this.SelectModel.IsSelect == false && this.GenerateLibraryCardNoModel.PersonTypeID == 1) {
        for (var i = 0; i < this.StaffList.length; i++) {
            this.StaffList[i].Active = false;

        }
    }
}


ChangeSelect  (item) {
    this.Count1 = 0;
    if (this.GenerateLibraryCardNoModel.PersonTypeID == 2) {
        for (var i = 0; i < this.StudentList.length; i++) {
            if (this.StudentList[i].Active) {
                this.Count1 = this.Count1 + 1

            }
        }
    }
    if (this.GenerateLibraryCardNoModel.PersonTypeID == 1) {
        for (var i = 0; i < this.StaffList.length; i++) {
            if (this.StaffList[i].Active) {
                this.Count1 = this.Count1 + 1

            }
        }
    }
    if (this.Count1 == this.StudentList.length) {
        this.SelectModel.IsSelect = true;

    }
    else {
        this.SelectModel.IsSelect = false;
    }

}

PersonList = [];
SaveGenerateLibraryCardNoStudent  () {


   this.spinnerService.show();
    for (var i = 0; i < this.StudentList.length; i++) {
        if (this.StudentList[i].Active == true && this.StudentList[i].LibCardNo == null) {
            var item = {
                StudentNo: this.StudentList[i].StudentNo,
                StudentID: this.StudentList[i].StudentID
            }
            this.PersonList.push(item);
        }

    }
    this.libraryservice.SaveGenerateLibraryCardNoStudent(JSON.stringify(this.GenerateLibraryCardNoModel), JSON.stringify(this.PersonList)).subscribe( (response:any)=> {
      this.spinnerService.hide();
        if (response.webResponse.Status) {

            this.PersonList.splice(0);
            this.GetGenerateLibraryCardNoStudent();
        }
        this.globalHelper.CheckActionStatus(response);
    });


}
SaveGenerateLibraryCardNoStaff  () {




    this.spinnerService.show();
    for (var i = 0; i < this.StaffList.length; i++) {
        if (this.StaffList[i].Active == true && this.StaffList[i].LibCardNo == null) {
            var item = {
                StaffIdentity: this.StaffList[i].StaffIdentity,
                StaffID: this.StaffList[i].StaffID
            }
            this.PersonList.push(item);
        }

    }

    this.libraryservice.SaveGenerateLibraryCardNoStaff(JSON.stringify(this.GenerateLibraryCardNoModel), JSON.stringify(this.PersonList)).subscribe( (response:any)=> {
       this.spinnerService.hide();
        if (response.webResponse.Status) {

            this.PersonList.splice(0);
            this.GetGenerateLibraryCardNoStaff();
        }
        this.globalHelper.CheckActionStatus(response);
    });

}
ngOnInit() {
    this.GetPersonType();
    this.GetEmployeeType();
    this.GetDesignation();
    this.GetDepartment();
    this.GetEmployeeCategory();

    this.GetClass();
    this.GetSection();
    //this.GetAccount();
    //this.GetTemplate();
    //this.GetSettings();
}

  

}
